import { call, put, select, takeEvery } from 'redux-saga/effects';
import { ACTIONS, BLOCK_SLOTS_FORM } from '../../constants';
import { formSelectors } from '../../../../../../selectors';
import { reset, startSubmit } from 'redux-form';
import { formatDateTimeISO } from '../../../../../../utils/datetimes';
import { dateSetTime } from '../../../LiveTimeSlotView/store/sagas/_helpers';
import { makeRequest } from '../../../../../../api/make-request';
import config from '../../../../../../../config';
import { IFetchDataResponse } from '../../../../../../api/types';
import { handleBulkBlockingResponse } from '../../utils/handleBulkBlockingResponse';

export function* process() {
  yield put(startSubmit(BLOCK_SLOTS_FORM.NAME));

  const formValues = yield select(formSelectors.getFormValues, BLOCK_SLOTS_FORM.NAME);

  const shoppingModes = formValues[BLOCK_SLOTS_FORM.FIELDS.SHOPPING_MODE].map(({ value }) => value);
  const note = formValues[BLOCK_SLOTS_FORM.FIELDS.NOTE];
  const storeIds = formValues[BLOCK_SLOTS_FORM.FIELDS.STORES];

  const { DAY, START, END } = BLOCK_SLOTS_FORM.FIELDS.TIME;

  const blockingSlots = formValues[BLOCK_SLOTS_FORM.FIELDS.TIMES].map((slot) => ({
    start: formatDateTimeISO(dateSetTime(slot[DAY], slot[START])),
    end: formatDateTimeISO(dateSetTime(slot[DAY], slot[END])),
    note,
  }));

  const timestamp = formatDateTimeISO(new Date(), false, true);
  const response: IFetchDataResponse<IBatchBlockingSlotsResponse> = yield call(makeRequest, {
    name: 'batchBlockingSlots',
    method: 'PUT',
    url: config.apiEndpoints.slotBatchBlocking,
    body: {
      shoppingModes,
      storeIds,
      blockingSlots,
    },
  });

  handleBulkBlockingResponse(response, timestamp);

  yield put(reset(BLOCK_SLOTS_FORM.NAME));
}

export default function* watchSubmitBulkBlockingSlotsAction() {
  yield takeEvery(ACTIONS.SUBMIT_BULK_BLOCKING_SLOTS, process);
}

export interface IBatchBlockingSlotsResponse {
  updatedBlockingSlots: Array<IBlockingSlotsResponse>;
  failedBlockingSlots: Array<IBlockingSlotsResponse & { error: string }>;
}
interface IBlockingSlotsResponse {
  store: string;
  start: string;
  end: string;
}
